import type { DashboardFilters } from "@/types";

import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";

import { DASHBOARD_CACHE_KEYS } from "./keys";

import { DashboardRepository } from "@/repositories/dashboard";

export const useGetDashboard = (filters: DashboardFilters) => {
  const repository = useRef(new DashboardRepository());

  return useQuery({
    queryKey: DASHBOARD_CACHE_KEYS.GET(filters),
    queryFn: async () => {
      return await repository.current.get(filters);
    },
    placeholderData: keepPreviousData,
  });
};
